import React from "react";
import { Route, Switch } from "react-router-dom";
import { Grid, GridColumn } from "@sumprio/ui";
import routes from "../../routes";
import { PageNotFound, SectionErrorBoundary } from "../error-pages";
import { history } from "helpers";
import HomeRedirect from "./HomeRedirect";
import "./MainContent.scss";

export interface MainContentProps {
  users?: unknown;
  matchRoute?: Record<string, unknown>;
}

export default function MainContent({ users: _users, matchRoute: _matchRoute }: MainContentProps) {
  return (
    <div className="main-content">
      <Grid
        className="main-content__grid"
        display="flex"
        flexDirection="column"
        flex={1}
        minHeight={0}
        minWidth={0}
        width="100%"
      >
        <GridColumn span={12} className="main-content__column">
          <div className="main-content__route">
            <div className="main-content__route-inner">
              <SectionErrorBoundary
                onRetry={() =>
                  history.replace(`${history.location.pathname}${history.location.search}`)
                }
              >
                <Switch>
                  <Route exact path="/" component={HomeRedirect} />
                  {routes.map((route, index) => (
                    <Route key={index} path={route.path} component={route.main} />
                  ))}
                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              </SectionErrorBoundary>
            </div>
          </div>
        </GridColumn>
      </Grid>
    </div>
  );
}
